import { RegisterFeeShareProposalForm } from './RegisterFeeShareProposalForm';

export const RegisterFeeShareProposalPage = () => {
  return (
      <RegisterFeeShareProposalForm />
  );
};
